<block>
    <block-title>
        {{ 'school.label' | translate }}
    </block-title>
    <block-content>
        <listItems [list]="list" type="school"></listItems>
    </block-content>
</block>

